import * as React from 'react'
import { Navigate } from 'react-router-dom'
import Cookies from 'universal-cookie'
import { ReactElement } from 'react'
import { routes } from './routes'

const cookies = new Cookies()

type Props = {
  children: ReactElement
}
export const PrivateWrapper: React.FC<Props> = ({ children }) => {
  const token = cookies.get('TOKEN')
  if (token) {
    return children
  } else {
    return <Navigate to={routes.Login} />
  }
}
